<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <svg viewBox="0 0 1024 1024" width="24" height="24">
                        <path d="M416 192V128h-32v64a96 96 0 0 1-192 0v-64h-32v64a128 128 0 0 0 256 0v-64zM896 192V128h-32v64a96 96 0 0 1-192 0v-64h-32v64a128 128 0 0 0 256 0v-64zM416 320v-64h-32v64a160 160 0 0 0 32 0zM608 320v-64h-32v64a160 160 0 0 0 32 0zM128 448v512a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V448a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32zM896 512H128v384h768V512z" fill="currentColor"/>
                    </svg>
                </div>
                <div class="header-text">
                    <h2>活动管理</h2>
                    <p>活动管理 · 活动配置管理</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.activityName" placeholder="搜索活动名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增活动
                </el-button>
            </div>
        </div>

        <!-- Table Layout -->
        <div class="bento-grid">
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        活动列表
                    </span>
                    <div class="card-actions">
                        <el-select v-model="formDatas.activityType" placeholder="活动类型" clearable size="mini"
                            class="filter-select" @change="partserch">
                            <el-option label="课前活动" :value="1"></el-option>
                            <el-option label="课中活动" :value="2"></el-option>
                            <el-option label="课后活动" :value="3"></el-option>
                        </el-select>
                        <el-select v-model="formDatas.activityClassId" placeholder="活动分类" clearable size="mini"
                            class="filter-select"  collapseTags @change="partserch">
                            <el-option v-for="item in activityClassOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            活动配置管理
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage" :height="tableHeight"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="activityId" stripe
                        @page-change="handlePageChange" @operate-btn-click="handleOperateBtnClick">
                        <template #cell-activityType="{ row }">
                            <span>{{ getActivityTypeText(row.activityType) }}</span>
                        </template>
                        <template #cell-activityClassIds="{ row }">
                            <span>{{ getActivityClassText(row.activityClassIds) }}</span>
                        </template>
                        <template #cell-activityStatus="{ row }">
                            <el-tag :type="row.activityStatus === 1 ? 'info' : 'success'" size="small" effect="plain">
                                {{ getStatusText(row.activityStatus) }}
                            </el-tag>
                        </template>
                        <template #cell-activityDifficulty="{ row }">
                            <span>{{ getDifficultyText(row.activityDifficulty) }}</span>
                        </template>
                        <template #cell-activityDuration="{ row }">
                            <span>{{ row.activityDuration || '-' }} 小时</span>
                        </template>
                        <template #cell-activityNeedMembersOne="{ row }">
                            <span>{{ row.activityNeedMembersOne || '-' }} 人</span>
                        </template>
                        <template #cell-activityNeedMembersTwo="{ row }">
                            <span>{{ row.activityNeedMembersTwo || '-' }} 人</span>
                        </template>
                        <template #cell-activityIntroduce="{ row }">
                            <el-tooltip :content="row.activityIntroduce || '暂无简介'" placement="top" :open-delay="300">
                                <span class="introduce-text">{{ row.activityIntroduce || '暂无简介' }}</span>
                            </el-tooltip>
                        </template>
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- 新增活动弹框 -->
        <aj-form-add ref="add_activity" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增活动信息" dialogWidth="800px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val"
            @item-change="handleItemChange">
            <!-- 所需物料自定义插槽 -->
            <!-- eslint-disable-next-line vue/no-unused-vars -->
            <template #activityNeeds-slot="{ formData }">
                <div class="material-form">
                    <!-- 统一的 Grid 表格容器 -->
                    <div class="material-needs-grid">
                        <!-- 表头行 -->
                        <div class="material-grid-header">
                            <span class="material-col">物料名称</span>
                            <span class="material-col">数量</span>
                            <span class="material-col">单位</span>
                            <span class="material-col">规格</span>
                            <span class="material-col">采购来源</span>
                            <span class="material-col">备注</span>
                            <span class="material-col">操作</span>
                        </div>
                        <!-- 数据行 -->
                        <div class="material-item-row" v-for="(item, index) in formData.activityNeeds" :key="index">
                            <el-input v-model="item.materialName" placeholder="物料名称"></el-input>
                            <el-input v-model="item.materialQuantity" placeholder="数量" type="number"></el-input>
                            <el-input v-model="item.materialUnit" placeholder="单位"></el-input>
                            <el-input v-model="item.materialSpecs" placeholder="规格"></el-input>
                            <el-input v-model="item.purchaseSource" placeholder="采购来源"></el-input>
                            <el-input v-model="item.materialRemark" placeholder="备注"></el-input>
                            <div class="material-delete-cell">
                                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                    class="material-delete-btn" @click="removeMaterial(index)"></el-button>
                            </div>
                        </div>
                    </div>
                    <div class="material-actions">
                        <el-button type="primary" size="small" @click="addMaterial">
                            <i class="el-icon-plus"></i> 添加物料
                        </el-button>
                        <el-button type="success" size="small" @click="triggerBatchImport('add')">
                            <i class="el-icon-upload2"></i> 批量导入
                        </el-button>
                        <el-button size="small" @click="downloadMaterialTemplate">
                            <i class="el-icon-download"></i> 下载模板
                        </el-button>
                    </div>
                    <!-- 批量导入文件输入 -->
                    <input type="file" ref="batchImportInputAdd" style="display: none" accept=".xlsx,.xls"
                        @change="handleBatchImport($event, 'add')">
                </div>
            </template>
            <!-- 活动流程自定义插槽 -->
            <template #activityProcess-slot="{ formData }">
                <div class="material-form">
                    <!-- 统一的 Grid 表格容器 -->
                    <div class="material-process-grid">
                        <!-- 表头行 -->
                        <div class="material-grid-header">
                            <span class="material-col">主题</span>
                            <span class="material-col">内容</span>
                            <span class="material-col">操作时长</span>
                            <span class="material-col">操作注意事项</span>
                            <span class="material-col">配套工具</span>
                            <span class="material-col">备注</span>
                            <span class="material-col">操作</span>
                        </div>
                        <!-- 数据行 -->
                        <div class="material-item-row" v-for="(item, index) in formData.activityProcess" :key="index">
                            <el-input v-model="item.theme" placeholder="主题"></el-input>
                            <el-input v-model="item.content" placeholder="内容"></el-input>
                            <el-input v-model="item.operationDuration" placeholder="操作时长"></el-input>
                            <el-input v-model="item.precautions" placeholder="操作注意事项"></el-input>
                            <el-input v-model="item.tools" placeholder="配套工具"></el-input>
                            <el-input v-model="item.remark" placeholder="备注"></el-input>
                            <div class="material-delete-cell">
                                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                    class="material-delete-btn" @click="removeProcess(index)"></el-button>
                            </div>
                        </div>
                    </div>
                    <div class="material-actions">
                        <el-button type="primary" size="small" @click="addProcess">
                            <i class="el-icon-plus"></i> 添加流程
                        </el-button>
                        <el-button type="success" size="small" @click="triggerBatchProcessImport('add')">
                            <i class="el-icon-upload2"></i> 批量导入
                        </el-button>
                        <el-button size="small" @click="downloadProcessTemplate">
                            <i class="el-icon-download"></i> 下载模板
                        </el-button>
                    </div>
                    <!-- 批量导入文件输入 -->
                    <input type="file" ref="batchProcessImportInputAdd" style="display: none" accept=".xlsx,.xls"
                        @change="handleBatchProcessImport($event, 'add')">
                </div>
            </template>
            <!-- 附件资料自定义插槽 -->
            <template #activityFiles-slot="{ formData }">
                <uploadOnly ref="uploadEnclosure" :multiple="true" :limit="10"
                    :historyFiles="formatUploadHistoryFiles(formData.activityFiles)" uploadBtnText="点击上传附件"
                    :showLimitInfo="false" @upload-success="handleUploadSuccess">
                </uploadOnly>
            </template>
        </aj-form-add>

        <!-- 编辑活动弹框 -->
        <aj-form-edit dialogWidth="800px" ref="edit_activity" :formConfig="formConfig" :formData="form"
            :dialogVisible="editDialogVisible" @update:dialogVisible="val => editDialogVisible = val"
            dialogTitle="编辑活动信息" labelWidth="100px" @confirm="handleEditConfirm">
            <!-- 所需物料自定义插槽 -->
            <!-- eslint-disable-next-line vue/no-unused-vars -->
            <template #activityNeeds-slot="{ formData }">
                <div class="material-form">
                    <!-- 统一的 Grid 表格容器 -->
                    <div class="material-needs-grid">
                        <!-- 表头行 -->
                        <div class="material-grid-header">
                            <span class="material-col">物料名称</span>
                            <span class="material-col">数量</span>
                            <span class="material-col">单位</span>
                            <span class="material-col">规格</span>
                            <span class="material-col">采购来源</span>
                            <span class="material-col">备注</span>
                            <span class="material-col">操作</span>
                        </div>
                        <!-- 数据行 -->
                        <div class="material-item-row" v-for="(item, index) in formData.activityNeeds" :key="index">
                            <el-input v-model="item.materialName" placeholder="物料名称"></el-input>
                            <el-input v-model="item.materialQuantity" placeholder="数量" type="number"></el-input>
                            <el-input v-model="item.materialUnit" placeholder="单位"></el-input>
                            <el-input v-model="item.materialSpecs" placeholder="规格"></el-input>
                            <el-input v-model="item.purchaseSource" placeholder="采购来源"></el-input>
                            <el-input v-model="item.materialRemark" placeholder="备注"></el-input>
                            <div class="material-delete-cell">
                                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                    class="material-delete-btn" @click="removeMaterial(index)"></el-button>
                            </div>
                        </div>
                    </div>
                    <div class="material-actions">
                        <el-button type="primary" size="small" @click="addMaterial">
                            <i class="el-icon-plus"></i> 添加物料
                        </el-button>
                        <el-button type="success" size="small" @click="triggerBatchImport('edit')">
                            <i class="el-icon-upload2"></i> 批量导入
                        </el-button>
                        <el-button size="small" @click="downloadMaterialTemplate">
                            <i class="el-icon-download"></i> 下载模板
                        </el-button>
                    </div>
                    <!-- 批量导入文件输入 -->
                    <input type="file" ref="batchImportInputEdit" style="display: none" accept=".xlsx,.xls"
                        @change="handleBatchImport($event, 'edit')">
                </div>
            </template>
            <!-- 活动流程自定义插槽 -->
            <template #activityProcess-slot="{ formData }">
                <div class="material-form">
                    <!-- 统一的 Grid 表格容器 -->
                    <div class="material-process-grid">
                        <!-- 表头行 -->
                        <div class="material-grid-header">
                            <span class="material-col">主题</span>
                            <span class="material-col">内容</span>
                            <span class="material-col">操作时长</span>
                            <span class="material-col">操作注意事项</span>
                            <span class="material-col">配套工具</span>
                            <span class="material-col">备注</span>
                            <span class="material-col">操作</span>
                        </div>
                        <!-- 数据行 -->
                        <div class="material-item-row" v-for="(item, index) in formData.activityProcess" :key="index">
                            <el-input v-model="item.theme" placeholder="主题"></el-input>
                            <el-input v-model="item.content" placeholder="内容"></el-input>
                            <el-input v-model="item.operationDuration" placeholder="操作时长"></el-input>
                            <el-input v-model="item.precautions" placeholder="操作注意事项"></el-input>
                            <el-input v-model="item.tools" placeholder="配套工具"></el-input>
                            <el-input v-model="item.remark" placeholder="备注"></el-input>
                            <div class="material-delete-cell">
                                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                    class="material-delete-btn" @click="removeProcess(index)"></el-button>
                            </div>
                        </div>
                    </div>
                    <div class="material-actions">
                        <el-button type="primary" size="small" @click="addProcess">
                            <i class="el-icon-plus"></i> 添加流程
                        </el-button>
                        <el-button type="success" size="small" @click="triggerBatchProcessImport('edit')">
                            <i class="el-icon-upload2"></i> 批量导入
                        </el-button>
                        <el-button size="small" @click="downloadProcessTemplate">
                            <i class="el-icon-download"></i> 下载模板
                        </el-button>
                    </div>
                    <!-- 批量导入文件输入 -->
                    <input type="file" ref="batchProcessImportInputEdit" style="display: none" accept=".xlsx,.xls"
                        @change="handleBatchProcessImport($event, 'edit')">
                </div>
            </template>
            <!-- 附件资料自定义插槽 -->
            <template #activityFiles-slot="{ formData }">
                <uploadOnly ref="uploadEnclosureEdit" :multiple="true" :limit="10"
                    :historyFiles="formatUploadHistoryFiles(formData.activityFiles)" uploadBtnText="点击上传附件"
                    :showLimitInfo="false" @upload-success="handleUploadSuccessEdit">
                </uploadOnly>
            </template>
        </aj-form-edit>

        <!-- 详情弹框 -->
        <el-dialog :visible.sync="detailDialogVisible" title="活动详情" width="700px" class="detail-dialog"
            :close-on-click-modal="false">
            <div class="detail-content">
                <!-- 基本信息 -->
                <div class="detail-section">
                    <div class="detail-section-title">
                        <i class="el-icon-info"></i>
                        基本信息
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">活动名称：</span>
                        <span class="detail-value">{{ detailData.activityName || '-' }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">活动类型：</span>
                        <span class="detail-value">{{ getActivityTypeText(detailData.activityType) }}</span>
                    </div>
                    <div class="detail-row" v-if="detailData.activityScene">
                        <span class="detail-label">活动场景：</span>
                        <span class="detail-value">{{ detailData.activityScene }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">活动时长：</span>
                        <span class="detail-value">{{ detailData.activityDuration || '-' }} 小时</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">活动难度：</span>
                        <span class="detail-value">{{ getDifficultyText(detailData.activityDifficulty) }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">引导师人数：</span>
                        <span class="detail-value">{{ detailData.activityNeedMembersOne || '-' }} 人</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">助教人数：</span>
                        <span class="detail-value">{{ detailData.activityNeedMembersTwo || '-' }} 人</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">活动状态：</span>
                        <span class="detail-value">
                            <el-tag :type="detailData.activityStatus === 1 ? 'info' : 'success'" size="small">
                                {{ getStatusText(detailData.activityStatus) }}
                            </el-tag>
                        </span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">创建时间：</span>
                        <span class="detail-value">{{ detailData.createtime || '-' }}</span>
                    </div>
                </div>

                <!-- 活动简介 -->
                <div class="detail-section">
                    <div class="detail-section-title">
                        <i class="el-icon-document"></i>
                        活动简介
                    </div>
                    <div class="detail-row" style="align-items: flex-start;">
                        <span class="detail-label">简介内容：</span>
                        <span class="detail-value" style="white-space: pre-wrap;">{{ detailData.activityIntroduce ||
                            '暂无简介'
                            }}</span>
                    </div>
                </div>

                <!-- 活动流程 -->
                <div class="detail-section">
                    <div class="detail-section-title">
                        <i class="el-icon-s-operation"></i>
                        活动流程
                    </div>
                    <div v-if="getProcessList(detailData.activityProcess).length > 0">
                        <table class="detail-table">
                            <thead>
                                <tr>
                                    <th style="width: 13%">主题</th>
                                    <th style="width: 20%">内容</th>
                                    <th style="width: 12%">操作时长</th>
                                    <th style="width: 18%">操作注意事项</th>
                                    <th style="width: 15%">配套工具</th>
                                    <th style="width: 12%">备注</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(process, index) in getProcessList(detailData.activityProcess)" :key="index">
                                    <td>{{ process.theme || '-' }}</td>
                                    <td>{{ process.content || '-' }}</td>
                                    <td>{{ process.operationDuration || '-' }}</td>
                                    <td>{{ process.precautions || '-' }}</td>
                                    <td>{{ process.tools || '-' }}</td>
                                    <td>{{ process.remark || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="detail-empty">暂无流程</div>
                </div>

                <!-- 所需物料 -->
                <div class="detail-section">
                    <div class="detail-section-title">
                        <i class="el-icon-box"></i>
                        所需物料
                    </div>
                    <div v-if="getMaterialsList(detailData.activityNeeds).length > 0">
                        <table class="detail-table">
                            <thead>
                                <tr>
                                    <th style="width: 16%">物料名称</th>
                                    <th style="width: 10%">数量</th>
                                    <th style="width: 8%">单位</th>
                                    <th style="width: 12%">规格</th>
                                    <th style="width: 14%">采购来源</th>
                                    <th style="width: 30%">备注</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(material, index) in getMaterialsList(detailData.activityNeeds)" :key="index">
                                    <td>{{ material.materialName || '未命名' }}</td>
                                    <td>{{ material.materialQuantity || 0 }}</td>
                                    <td>{{ material.materialUnit || '-' }}</td>
                                    <td>{{ material.materialSpecs || '-' }}</td>
                                    <td>{{ material.purchaseSource || '-' }}</td>
                                    <td>{{ material.materialRemark || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="detail-empty">暂无物料</div>
                </div>

                <!-- 附件资料 -->
                <div class="detail-section">
                    <div class="detail-section-title">
                        <i class="el-icon-folder-opened"></i>
                        附件资料
                    </div>
                    <div v-if="getFilesList(detailData.activityFiles).length > 0" class="detail-file-list">
                        <div v-for="(file, index) in getFilesList(detailData.activityFiles)" :key="index"
                            class="detail-file-item" :class="getFilePreviewClass(file)"
                            @click="previewAttachment(file)">
                            <div class="file-icon">
                                <template v-if="getFileType(file) === 'image'">
                                    <i class="el-icon-picture" style="color: #409eff;"></i>
                                </template>
                                <template v-else-if="getFileType(file) === 'video'">
                                    <i class="el-icon-video-camera" style="color: #e6a23c;"></i>
                                </template>
                                <template v-else-if="getFileType(file) === 'pdf'">
                                    <i class="el-icon-document" style="color: #f56c6c;"></i>
                                </template>
                                <template v-else-if="getFileType(file) === 'word'">
                                    <i class="el-icon-document" style="color: #409eff;"></i>
                                </template>
                                <template v-else-if="getFileType(file) === 'excel'">
                                    <i class="el-icon-document" style="color: #67c23a;"></i>
                                </template>
                                <template v-else-if="getFileType(file) === 'ppt'">
                                    <i class="el-icon-document" style="color: #e6a23c;"></i>
                                </template>
                                <template v-else>
                                    <i class="el-icon-document"></i>
                                </template>
                            </div>
                            <div class="file-info">
                                <div class="file-name">{{ getFileName(file) }}</div>
                                <div class="file-preview-hint">点击预览</div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="detail-empty">暂无附件</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getAjActivityListOperation,
    getAjActivityDetails,
    addAjActivity,
    updateAjActivity,
    deleteAjActivity,
    getAjActivityClassListChild
} from "../../api/api";
import uploadOnly from "../../components/myUpload/ajUpload.vue";
import ajFormAdd from "../../components/ajForm/ajFormAdd.vue";
import ajFormEdit from "../../components/ajForm/ajFormEdit.vue";

export default {
    name: "activityManagement",
    components: {
        uploadOnly,
        ajFormAdd,
        ajFormEdit
    },
    data() {
        return {
            addDialogVisible: false,
            editDialogVisible: false,
            detailDialogVisible: false,
            detailData: {},
            form: {},
            formConfig: [],
            // 活动分类下拉选项
            activityClassOptions: [],
            totalCount: 0,
            tableData: [],
            tableColumns: [
                { type: 'index', label: '序号', width: 80, fixed: 'left', align: 'center' },
                { label: '活动名称', prop: 'activityName', minWidth: 150, align: 'center', fixed: 'left' },
                { label: '活动类型', prop: 'activityType', width: 100, align: 'center' },
                { label: '活动分类', prop: 'activityClassIds', width: 150, align: 'center' },
                { label: '活动场景', prop: 'activityScene', width: 150, align: 'center' },
                { label: '活动时长', prop: 'activityDuration', width: 100, align: 'center' },
                { label: '活动难度', prop: 'activityDifficulty', width: 100, align: 'center' },
                { label: '引导师人数', prop: 'activityNeedMembersOne', width: 100, align: 'center' },
                { label: '助教人数', prop: 'activityNeedMembersTwo', width: 100, align: 'center' },
                { label: '状态', prop: 'activityStatus', width: 100, align: 'center' },
                { label: '活动简介', prop: 'activityIntroduce', minWidth: 200, align: 'center' },
                { label: '创建时间', prop: 'createtime', width: 180, align: 'center' },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 200,
                    buttons: [
                        { key: 'detail', text: '详情', icon: 'el-icon-view' },
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete', type: 'danger' }
                    ]
                }
            ],
            tableEditable: false,
            tableHeight: 400,
            watchFlag: true,
            windheight: 0,
            colorList: [
                'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
                'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
                'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
            ],
            formDatas: {
                activityName: '',
                activityType: null,
                activityClassIds: [],
                currentPage: 1,
                pageSize: 20,
            },
            // 附件上传相关
            enclosureFiles: [],
            enclosureFilesEdit: [],
            // 附件预览相关
            previewImageUrl: '',
            imagePreviewVisible: false,
        };
    },

    created() {
        this.getFormInit();
        this.getActivityClassOptions();
        this.partserch();
    },

    watch: {
    },
    mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        // 获取活动分类下拉选项
        getActivityClassOptions() {
            getAjActivityClassListChild().then(res => {
                if (res.data) {
                    this.activityClassOptions = res.data.map(item => ({
                        label: `${item.activityClassParentName || '一级分类'} - ${item.activityClassName}`,
                        value: item.activityClassId
                    }));
                }
            });
        },
        handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                if (cardContent) {
                    this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset: 100 });
                } else {
                    // 备用计算方式
                    const windheight = this.$store.state.windheight || window.innerHeight;
                    this.tableHeight = windheight - 200 - windheight * 0.04;
                }
            });
        },
        // 分页变化
        handlePageChange({ currentPage, pageSize }) {
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            this.getListData();
        },

        // 操作按钮点击
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'detail':
                    this.handleDetail(row);
                    break;
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
            }
        },

        // 查看详情
        handleDetail(row) {
            getAjActivityDetails({ activityId: row.activityId }).then(res => {
                if (res.status === 200) {
                    this.detailData = res.data || {};
                    this.detailDialogVisible = true;
                } else {
                    this.$message.error(res.msg || '获取详情失败');
                }
            });
        },
        // 表单配置项
        getFormInit() {
            this.formConfig = [
                [{ type: 'input', label: '活动名称', prop: 'activityName', placeholder: '请输入活动名称', span: 24, required: true }],
                [
                    { type: 'select', label: '活动类型', prop: 'activityType', span: 12,
                      options: [
                        { label: '课前活动', value: 1 },
                        { label: '课中活动', value: 2 },
                        { label: '课后活动', value: 3 }
                      ],
                      placeholder: '请选择活动类型', required: true },
                    { type: 'input', label: '活动时长', prop: 'activityDuration', placeholder: '请输入活动时长(小时)', span: 12, inputType: 'number' }
                ],
                [
                    { type: 'input', label: '活动场景', prop: 'activityScene', placeholder: '请输入活动场景', span: 12 },
                    {
                        type: 'select', label: '活动难度', prop: 'activityDifficulty', placeholder: '请选择活动难度', span: 12,
                        options: [
                            { label: '简单', value: 1 },
                            { label: '中等', value: 2 },
                            { label: '困难', value: 3 }
                        ]
                    }
                ],
                [
                    { type: 'input', label: '引导师人数', prop: 'activityNeedMembersOne', placeholder: '请输入引导师人数', span: 12, inputType: 'number' },
                    { type: 'input', label: '助教人数', prop: 'activityNeedMembersTwo', placeholder: '请输入助教人数', span: 12, inputType: 'number' }
                ],
                [
                    {
                        type: 'select', label: '活动分类', prop: 'activityClassIds', span: 12,
                        options: this.activityClassOptions,
                        placeholder: '请选择活动分类', multiple: true, collapseTags: true
                    },
                    {
                        type: 'select', label: '状态', prop: 'activityStatus', span: 12,
                        options: [
                            { label: '草稿', value: 1 },
                            { label: '已发布', value: 2 }
                        ],
                        placeholder: '请选择状态'
                    }
                ],
                [{ type: 'textarea', label: '活动简介', prop: 'activityIntroduce', placeholder: '请输入活动简介', span: 24, rows: 3 }],
                [{ type: 'slot', label: '活动流程', prop: 'activityProcess', span: 24 }],
                [{ type: 'slot', label: '所需物料', prop: 'activityNeeds', span: 24 }],
                [{ type: 'slot', label: '附件资料', prop: 'activityFiles', span: 24 }],
            ];
            this.form = {
                activityName: '',
                activityType: '',
                activityScene: '',
                activityDuration: '',
                activityDifficulty: null,
                activityNeedMembersOne: '',
                activityNeedMembersTwo: '',
                activityClassIds: [],
                activityStatus: 1,
                activityIntroduce: '',
                activityProcess: [],
                activityNeeds: [],
                activityFiles: ''
            };
        },

        // 表单项变更监听
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },

        getRandomColor(id) {
            const index = id % this.colorList.length;
            return this.colorList[index];
        },

        // 获取附件列表
        getEnclosureList(enclosure) {
            if (!enclosure) return [];
            try {
                if (typeof enclosure === 'string') {
                    return JSON.parse(enclosure);
                }
                return enclosure;
            } catch {
                // 如果是逗号分隔的字符串
                if (typeof enclosure === 'string' && enclosure.includes(',')) {
                    return enclosure.split(',').map(item => ({ name: item.trim() }));
                }
                return [];
            }
        },



        // 获取活动分类文本
        getActivityClassText(classIds) {
            if (!classIds) return '-';
            let ids = [];
            if (typeof classIds === 'string') {
                try {
                    ids = JSON.parse(classIds);
                } catch {
                    ids = classIds.split(',');
                }
            } else if (Array.isArray(classIds)) {
                ids = classIds;
            }
            if (!ids.length) return '-';
            const names = ids.map(id => {
                const item = this.activityClassOptions.find(opt => opt.value === id);
                return item ? item.label : id;
            });
            return names.join(', ');
        },

        // 获取物料列表
        getMaterialsList(needs) {
            if (!needs) return [];
            try {
                if (typeof needs === 'string') {
                    return JSON.parse(needs);
                }
                return needs;
            } catch {
                return [];
            }
        },

        // 获取活动流程列表
        getProcessList(process) {
            if (!process) return [];
            try {
                if (typeof process === 'string') {
                    return JSON.parse(process);
                }
                return process;
            } catch {
                return [];
            }
        },

        // 获取附件列表（activityFiles 是字符串数组格式 ["url1", "url2"]）
        getFilesList(files) {
            if (!files) return [];
            try {
                if (typeof files === 'string') {
                    return JSON.parse(files);
                }
                return files;
            } catch {
                return [];
            }
        },

        // 格式化上传组件需要的历史文件格式
        formatUploadHistoryFiles(files) {
            if (!files || !Array.isArray(files)) return [];
            // 如果已经是对象数组，直接返回
            if (files.length > 0 && typeof files[0] === 'object' && files[0].url) {
                return files;
            }
            // 如果是字符串数组，转换为对象数组
            return files.map(url => {
                const fileName = url.split('/').pop() || '附件';
                const extension = fileName.split('.').pop()?.toLowerCase() || '';
                // 判断文件类型
                const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'];
                const videoExts = ['mp4', 'avi', 'mov', 'flv', 'wmv', 'mkv', 'webm', 'mpeg'];
                const audioExts = ['mp3', 'wav', 'ogg', 'flac', 'aac', 'wma', 'm4a'];
                let type = 'document';
                if (imageExts.includes(extension)) type = 'image';
                else if (videoExts.includes(extension)) type = 'video';
                else if (audioExts.includes(extension)) type = 'audio';
                return {
                    name: fileName,
                    url: url,
                    type: type,
                    extension: extension
                };
            });
        },

        // 格式化活动类型图片
        formatActivityTypeImage(imageUrl) {
            if (!imageUrl) return [];
            return [{
                name: imageUrl.split('/').pop() || '活动类型图片',
                url: imageUrl,
                type: 'image',
                extension: imageUrl.split('.').pop()?.toLowerCase() || 'jpg'
            }];
        },

        // 新增弹框 - 活动类型图片上传成功回调
        handleActivityTypeUploadSuccess(fileList) {
            if (fileList && fileList.length > 0) {
                this.form.activityType = fileList[0].url;
            } else {
                this.form.activityType = '';
            }
        },

        // 编辑弹框 - 活动类型图片上传成功回调
        handleActivityTypeUploadSuccessEdit(fileList) {
            if (fileList && fileList.length > 0) {
                this.form.activityType = fileList[0].url;
            } else {
                this.form.activityType = '';
            }
        },

        // 从URL中提取文件名
        getFileName(url) {
            if (!url) return '附件';
            // 尝试解码URL
            try {
                url = decodeURIComponent(url);
            } catch (e) {
                // 忽略解码错误
            }
            const fileName = url.split('/').pop() || '附件';
            // 去除查询参数
            return fileName.split('?')[0] || '附件';
        },

        // 获取文件类型
        getFileType(url) {
            if (!url) return 'unknown';
            const fileName = this.getFileName(url).toLowerCase();
            const ext = fileName.split('.').pop() || '';

            const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'];
            const videoExts = ['mp4', 'avi', 'mov', 'flv', 'wmv', 'mkv', 'webm', 'mpeg', '3gp', 'rmvb'];

            if (imageExts.includes(ext)) return 'image';
            if (videoExts.includes(ext)) return 'video';
            if (ext === 'pdf') return 'pdf';
            if (['doc', 'docx'].includes(ext)) return 'word';
            if (['xls', 'xlsx'].includes(ext)) return 'excel';
            if (['ppt', 'pptx'].includes(ext)) return 'ppt';
            return 'other';
        },

        // 获取文件预览样式类
        getFilePreviewClass(url) {
            const type = this.getFileType(url);
            return `file-preview-${type}`;
        },

        // 预览附件
        previewAttachment(url) {
            if (!url) return;
            const fileName = this.getFileName(url);
            const fileType = this.getFileType(url);

            // 图片类型 - 使用Element UI的图片预览
            if (fileType === 'image') {
                this.previewImageUrl = url;
                this.imagePreviewVisible = true;
                return;
            }

            // 视频类型 - 新窗口播放
            if (fileType === 'video') {
                window.open(url, '_blank');
                return;
            }

            // PDF类型 - 使用iframe预览或新窗口
            if (fileType === 'pdf') {
                const pdfWindow = window.open('', '_blank');
                pdfWindow.document.write(`
                    <html>
                        <head>
                            <title>预览 - ${fileName}</title>
                            <style>
                                * { margin: 0; padding: 0; }
                                iframe { width: 100vw; height: 100vh; border: none; }
                            </style>
                        </head>
                        <body>
                            <iframe src="${url}"></iframe>
                        </body>
                    </html>
                `);
                return;
            }

            // Office文档类型 (Word, Excel, PPT) - 使用微软Office在线预览
            if (['word', 'excel', 'ppt'].includes(fileType)) {
                // 尝试使用微软Office在线预览
                let previewUrl = '';
                if (fileType === 'word') {
                    previewUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
                } else if (fileType === 'excel') {
                    previewUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
                } else if (fileType === 'ppt') {
                    previewUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
                }
                window.open(previewUrl, '_blank');
                return;
            }

            // 其他类型 - 直接打开
            window.open(url, '_blank');
        },

        getDifficultyText(difficulty) {
            const difficultyMap = {
                1: '简单',
                2: '中等',
                3: '困难'
            };
            return difficultyMap[difficulty] || '未知难度';
        },

        getActivityTypeText(type) {
            const typeMap = {
                1: '课前活动',
                2: '课中活动',
                3: '课后活动'
            };
            return typeMap[type] || '未知类型';
        },

        getStatusText(status) {
            const statusMap = {
                1: '草稿',
                2: '已发布'
            };
            return statusMap[status] || '未知';
        },

        // 添加物料
        addMaterial() {
            if (!this.form.activityNeeds) {
                this.form.activityNeeds = [];
            }
            this.form.activityNeeds.push({
                materialName: '',
                materialQuantity: '',
                materialUnit: '',
                materialSpecs: '',
                purchaseSource: '',
                materialRemark: ''
            });
        },

        // 删除物料
        removeMaterial(index) {
            this.form.activityNeeds.splice(index, 1);
        },

        // 添加活动流程
        addProcess() {
            this.form.activityProcess.push({
                theme: '',
                content: '',
                operationDuration: '',
                precautions: '',
                tools: '',
                remark: ''
            });
        },

        // 删除活动流程
        removeProcess(index) {
            this.form.activityProcess.splice(index, 1);
        },

        // 触发批量导入文件选择
        triggerBatchImport(type) {
            const refName = type === 'add' ? 'batchImportInputAdd' : 'batchImportInputEdit';
            this.$nextTick(() => {
                const input = this.$refs[refName];
                if (input) {
                    input.click();
                }
            });
        },

        // 处理批量导入
        handleBatchImport(event, type) {
            const file = event.target.files[0];
            if (!file) return;

            // 清空input以允许再次选择相同文件
            event.target.value = '';

            const fileName = file.name.toLowerCase();
            if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
                this.parseExcel(file, type);
            } else {
                this.$message.warning('请选择 Excel 文件 (.xlsx 或 .xls)');
            }
        },

        // 解析Excel文件（需要xlsx库）
        parseExcel(file, type) {
            // 动态加载xlsx库
            if (typeof XLSX === 'undefined') {
                this.$message.warning('Excel解析库未加载，请使用CSV格式或联系管理员');
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                    if (jsonData.length < 2) {
                        this.$message.warning('文件内容为空或格式不正确');
                        return;
                    }

                    // 解析数据（跳过表头）
                    const materials = [];
                    for (let i = 1; i < jsonData.length; i++) {
                        const row = jsonData[i];
                        if (row && row[0]) {
                            materials.push({
                                materialName: row[0] || '',
                                materialQuantity: row[1] || '',
                                materialUnit: row[2] || '',
                                materialSpecs: row[3] || '',
                                purchaseSource: row[4] || '',
                                materialRemark: row[5] || ''
                            });
                        }
                    }

                    this.applyBatchMaterials(materials, type);
                    this.$message.success(`成功导入 ${materials.length} 条物料数据`);
                } catch (error) {
                    this.$message.error('解析Excel文件失败：' + error.message);
                }
            };
            reader.readAsArrayBuffer(file);
        },

        // 应用批量导入的物料数据
        applyBatchMaterials(materials, type) {
            if (!this.form.activityNeeds) {
                this.form.activityNeeds = [];
            }
            this.form.activityNeeds.push(...materials);
        },

        // 下载物料导入模板
        downloadMaterialTemplate() {
            // 创建Excel格式的模板（使用HTML表格方式）
            const tableHtml = `
                <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
                <head><meta charset="UTF-8"></head>
                <body>
                <table border="1">
                    <tr>
                        <td style="background-color: #FFE699; font-weight: bold;">物料名称</td>
                        <td style="background-color: #FFE699; font-weight: bold;">数量</td>
                        <td style="background-color: #FFE699; font-weight: bold;">单位</td>
                        <td style="background-color: #FFE699; font-weight: bold;">规格</td>
                        <td style="background-color: #FFE699; font-weight: bold;">采购来源</td>
                        <td style="background-color: #FFE699; font-weight: bold;">备注</td>
                    </tr>
                    <tr>
                        <td>示例物料1</td>
                        <td>10</td>
                        <td>个</td>
                        <td>10cm*10cm</td>
                        <td>淘宝</td>
                        <td>这是备注</td>
                    </tr>
                    <tr>
                        <td>示例物料2</td>
                        <td>5</td>
                        <td>箱</td>
                        <td>大号</td>
                        <td>京东</td>
                        <td>这是备注2</td>
                    </tr>
                </table>
                </body>
                </html>
            `;

            // 创建Blob并下载
            const blob = new Blob([tableHtml], { type: 'application/vnd.ms-excel' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = '物料导入模板.xls';
            link.click();
            URL.revokeObjectURL(link.href);
        },

        // 触发活动流程批量导入文件选择
        triggerBatchProcessImport(type) {
            const refName = type === 'add' ? 'batchProcessImportInputAdd' : 'batchProcessImportInputEdit';
            this.$nextTick(() => {
                const input = this.$refs[refName];
                if (input) {
                    input.click();
                }
            });
        },

        // 处理活动流程批量导入
        handleBatchProcessImport(event, type) {
            const file = event.target.files[0];
            if (!file) return;

            // 清空input以允许再次选择相同文件
            event.target.value = '';

            const fileName = file.name.toLowerCase();
            if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
                this.parseProcessExcel(file, type);
            } else {
                this.$message.warning('请选择 Excel 文件 (.xlsx 或 .xls)');
            }
        },

        // 解析活动流程Excel文件
        parseProcessExcel(file, type) {
            if (typeof XLSX === 'undefined') {
                this.$message.warning('Excel解析库未加载，请使用CSV格式或联系管理员');
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                    if (jsonData.length < 2) {
                        this.$message.warning('文件内容为空或格式不正确');
                        return;
                    }

                    // 解析数据（跳过表头）
                    const processes = [];
                    for (let i = 1; i < jsonData.length; i++) {
                        const row = jsonData[i];
                        if (row && row[0]) {
                            processes.push({
                                theme: row[0] || '',
                                content: row[1] || '',
                                operationDuration: row[2] || '',
                                precautions: row[3] || '',
                                tools: row[4] || '',
                                remark: row[5] || ''
                            });
                        }
                    }

                    this.applyBatchProcesses(processes, type);
                    this.$message.success(`成功导入 ${processes.length} 条流程数据`);
                } catch (error) {
                    this.$message.error('解析Excel文件失败：' + error.message);
                }
            };
            reader.readAsArrayBuffer(file);
        },

        // 应用批量导入的活动流程数据
        applyBatchProcesses(processes, _type) {
            if (!this.form.activityProcess) {
                this.form.activityProcess = [];
            }
            this.form.activityProcess.push(...processes);
        },

        // 下载活动流程导入模板
        downloadProcessTemplate() {
            const tableHtml = `
                <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
                <head><meta charset="UTF-8"></head>
                <body>
                <table border="1">
                    <tr>
                        <td style="background-color: #B4C7E7; font-weight: bold;">主题</td>
                        <td style="background-color: #B4C7E7; font-weight: bold;">内容</td>
                        <td style="background-color: #B4C7E7; font-weight: bold;">操作时长</td>
                        <td style="background-color: #B4C7E7; font-weight: bold;">操作注意事项</td>
                        <td style="background-color: #B4C7E7; font-weight: bold;">配套工具</td>
                        <td style="background-color: #B4C7E7; font-weight: bold;">备注</td>
                    </tr>
                    <tr>
                        <td>开场介绍</td>
                        <td>自我介绍和活动介绍</td>
                        <td>5分钟</td>
                        <td>注意把握时间</td>
                        <td>麦克风、投影仪</td>
                        <td>这是备注</td>
                    </tr>
                    <tr>
                        <td>分组讨论</td>
                        <td>小组讨论主题</td>
                        <td>20分钟</td>
                        <td>鼓励积极参与</td>
                        <td>白板、彩笔</td>
                        <td>这是备注2</td>
                    </tr>
                </table>
                </body>
                </html>
            `;

            const blob = new Blob([tableHtml], { type: 'application/vnd.ms-excel' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = '活动流程导入模板.xls';
            link.click();
            URL.revokeObjectURL(link.href);
        },

        // 新增弹框 - 上传成功回调
        handleUploadSuccess(fileList) {
            this.form.activityFiles = fileList;
        },

        // 编辑弹框 - 上传成功回调
        handleUploadSuccessEdit(fileList) {
            this.form.activityFiles = fileList;
        },

        // 弹框关闭时重置表单
        handleDialogClose(type) {
            this.form = {
                activityName: '',
                activityType: '',
                activityScene: '',
                activityDuration: '',
                activityDifficulty: null,
                activityStatus: 1,
                activityIntroduce: '',
                activityProcess: '',
                activityNeeds: [],
                activityFiles: ''
            };
            // 清空附件列表
            if (type === 'add') {
                this.enclosureFiles = [];
            } else if (type === 'edit') {
                this.enclosureFilesEdit = [];
            }
        },

        // 编辑提交
        handleEditConfirm({ data }) {
            if (!data.activityName) {
                this.$message.warning('请输入活动名称');
                return;
            }
            if (!data.activityType) {
                this.$message.warning('请选择活动类型');
                return;
            }
            this.$confirm('确认编辑该活动吗？', '提示', {
                type: 'success'
            }).then(() => {
                const newData = JSON.parse(JSON.stringify(data));
                // 处理活动分类字段 - 转为JSON字符串
                if (newData.activityClassIds && Array.isArray(newData.activityClassIds)) {
                    newData.activityClassIds = JSON.stringify(newData.activityClassIds);
                }
                // 处理activityNeeds字段，转为JSON字符串
                if (newData.activityNeeds && Array.isArray(newData.activityNeeds)) {
                    // 过滤掉空物料
                    newData.activityNeeds = newData.activityNeeds.filter(item => item.materialName);
                    newData.activityNeeds = JSON.stringify(newData.activityNeeds);
                }
                // 处理activityProcess字段，转为JSON字符串
                if (newData.activityProcess && Array.isArray(newData.activityProcess)) {
                    // 过滤掉空流程
                    newData.activityProcess = newData.activityProcess.filter(item => item.content);
                    newData.activityProcess = JSON.stringify(newData.activityProcess);
                } else {
                    newData.activityProcess = '[]';
                }
                // 处理附件资料字段 - 使用 form.activityFiles
                const files = this.form.activityFiles || [];
                if (files.length > 0) {
                    const urls = files.map(item => item.url || item).filter(url => url);
                    if (urls.length > 0) {
                        newData.activityFiles = JSON.stringify(urls);
                    } else {
                        newData.activityFiles = '[]';
                    }
                } else {
                    newData.activityFiles = '[]';
                }
                updateAjActivity(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_activity.cancelDiaLog();
                        this.form.activityFiles = [];
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '编辑失败');
                    }
                });
            }).catch(() => { });
        },

        // 新增提交
        handleAddConfirm({ data }) {
            if (!data.activityName) {
                this.$message.warning('请输入活动名称');
                return;
            }
            if (!data.activityType) {
                this.$message.warning('请选择活动类型');
                return;
            }
            this.$confirm('确认新增该活动吗？', '提示', {
                type: 'success'
            }).then(() => {
                const newData = JSON.parse(JSON.stringify(data));
                // 处理活动分类字段 - 转为JSON字符串
                if (newData.activityClassIds && Array.isArray(newData.activityClassIds)) {
                    newData.activityClassIds = JSON.stringify(newData.activityClassIds);
                }
                // 处理activityNeeds字段，转为JSON字符串
                if (newData.activityNeeds && Array.isArray(newData.activityNeeds)) {
                    // 过滤掉空物料
                    newData.activityNeeds = newData.activityNeeds.filter(item => item.materialName);
                    newData.activityNeeds = JSON.stringify(newData.activityNeeds);
                } else {
                    newData.activityNeeds = '[]';
                }
                // 处理activityProcess字段，转为JSON字符串
                if (newData.activityProcess && Array.isArray(newData.activityProcess)) {
                    // 过滤掉空流程
                    newData.activityProcess = newData.activityProcess.filter(item => item.content);
                    newData.activityProcess = JSON.stringify(newData.activityProcess);
                } else {
                    newData.activityProcess = '[]';
                }
                // 处理附件资料字段 - 使用 form.activityFiles
                const files = this.form.activityFiles || [];
                if (files.length > 0) {
                    const urls = files.map(item => item.url || item).filter(url => url);
                    if (urls.length > 0) {
                        newData.activityFiles = JSON.stringify(urls);
                    } else {
                        newData.activityFiles = '[]';
                    }
                } else {
                    newData.activityFiles = '[]';
                }
                addAjActivity(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_activity.cancelDiaLog();
                        this.form.activityFiles = [];
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '新增失败');
                    }
                });
            }).catch(() => { });
        },

        addForm() {
            this.getFormInit();
            this.form.activityFiles = [];
            this.form.activityType = '';
            this.form.activityScene = '';
            this.addDialogVisible = true;
        },

        // 编辑操作 - 使用详情接口获取完整数据
        handleEdit(row) {
            this.getFormInit();
            getAjActivityDetails({ activityId: row.activityId }).then(res => {
                if (res.status === 200) {
                    const s = res.data || {};
                    // 解析activityClassIds字段 - JSON字符串转数组
                    if (s.activityClassIds) {
                        try {
                            const parsed = typeof s.activityClassIds === 'string' ? JSON.parse(s.activityClassIds) : s.activityClassIds;
                            s.activityClassIds = Array.isArray(parsed) ? parsed : [];
                        } catch {
                            s.activityClassIds = [];
                        }
                    } else {
                        s.activityClassIds = [];
                    }
                    // 解析activityNeeds字段
                    if (s.activityNeeds) {
                        try {
                            const parsed = typeof s.activityNeeds === 'string' ? JSON.parse(s.activityNeeds) : s.activityNeeds;
                            s.activityNeeds = Array.isArray(parsed) ? parsed : [];
                        } catch {
                            s.activityNeeds = [];
                        }
                    } else {
                        s.activityNeeds = [];
                    }
                    // 解析activityProcess字段
                    if (s.activityProcess) {
                        try {
                            const parsed = typeof s.activityProcess === 'string' ? JSON.parse(s.activityProcess) : s.activityProcess;
                            s.activityProcess = Array.isArray(parsed) ? parsed : [];
                        } catch {
                            s.activityProcess = [];
                        }
                    } else {
                        s.activityProcess = [];
                    }
                    // 解析activityFiles字段（字符串数组格式 ["url1", "url2"]）
                    // 直接设置到 form.activityFiles，让 ajForm 组件自动处理回显
                    if (s.activityFiles) {
                        try {
                            const parsed = typeof s.activityFiles === 'string' ? JSON.parse(s.activityFiles) : s.activityFiles;
                            if (Array.isArray(parsed)) {
                                s.activityFiles = parsed;
                            } else {
                                s.activityFiles = [];
                            }
                        } catch {
                            s.activityFiles = [];
                        }
                    } else {
                        s.activityFiles = [];
                    }
                    this.form = s;
                    this.editDialogVisible = true;
                } else {
                    this.$message.error(res.msg || '获取详情失败');
                }
            });
        },

        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该活动吗？',
                    type: 'danger'
                });
                deleteAjActivity({ activityId: row.activityId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },

        // 获取列表数据
        getListData() {
            getAjActivityListOperation(this.formDatas).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data || [];
                    this.totalCount = res.total || 0;
                }
            });
        },

        partserch() {
            this.formDatas.currentPage = 1;
            this.getListData();
        },

        resetSearch() {
            this.formDatas.activityName = '';
            this.formDatas.activityType = null;
            this.formDatas.activityClassIds = [];
            this.partserch();
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: 100%;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-search {
    width: 220px;
}

.type-select {
    width: 130px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(245, 158, 11, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Card Grid */
.card-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
}

/* Activity Card */
.activity-card {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    border: 1px solid #f1f5f9;
}

.activity-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.card-cover {
    height: 120px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.card-cover::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
}

.card-cover::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.1), transparent);
}

.activity-type-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    padding: 6px 14px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 24px;
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(8px);
    z-index: 2;
}

.activity-status-badge {
    position: absolute;
    top: 12px;
    left: 12px;
    padding: 6px 14px;
    border-radius: 24px;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 2;
}

.activity-status-badge.status-1 {
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
    color: white;
}

.activity-status-badge.status-2 {
    background: linear-gradient(135deg, #34d399 0%, #059669 100%);
    color: white;
}

.card-body {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.activity-title {
    margin: 0 0 14px;
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.4;
}

.activity-info {
    display: flex;
    gap: 16px;
    margin-bottom: 14px;
    flex-wrap: wrap;
}

.info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #64748b;
    background: #f8fafc;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}

.info-item i {
    color: #94a3b8;
    font-size: 14px;
}

.activity-introduce {
    margin: 0 0 16px;
    font-size: 14px;
    color: #64748b;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    flex: 1;
}

/* Activity Materials */
.activity-materials,
.activity-files {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #f1f5f9;
}

.materials-label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    display: block;
    margin-bottom: 8px;
}

.material-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.material-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 10px;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border: 1px solid #bae6fd;
    border-radius: 6px;
    font-size: 12px;
    color: #0369a1;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.2s;
}

.material-tag:hover {
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
    transform: scale(1.02);
}

.material-tag.file-tag {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border-color: #fcd34d;
    color: #92400e;
}

.material-tag.file-tag i {
    color: #d97706;
}

.no-materials {
    font-size: 12px;
    color: #94a3b8;
    font-style: italic;
}

/* Enclosure List */
.enclosure-list {
    margin-top: 8px;
}

.enclosure-list .el-tag {
    margin-right: 8px;
    margin-bottom: 4px;
}

/* Upload */
.activity-upload ::v-deep .el-upload__tip {
    margin-top: 5px;
    color: #94a3b8;
}

.card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 20px;
    border-top: 1px solid #f1f5f9;
    background: #fafbfc;
}

.create-time {
    font-size: 12px;
    color: #94a3b8;
    display: flex;
    align-items: center;
    gap: 6px;
}

.create-time::before {
    content: '';
    width: 8px;
    height: 8px;
    background: #10b981;
    border-radius: 50%;
}

.card-actions {
    display: flex;
    gap: 12px;
}

.card-actions .el-button {
    padding: 6px 14px;
    font-size: 13px;
    color: #64748b;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    transition: all 0.2s;
}

.card-actions .el-button:hover {
    color: #f59e0b;
    border-color: #f59e0b;
    background: #fffbeb;
}

.card-actions .delete-btn:hover {
    color: #ef4444;
    border-color: #ef4444;
    background: #fef2f2;
}

/* Material Form - 使用 Grid 布局确保列宽完全对齐 */
.material-form {
    width: 100%;
}

.material-actions {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

/* 物料表格 - 7列布局 */
.material-needs-grid {
    display: grid;
    grid-template-columns: 16% 10% 8% 12% 14% 30% 10%;
    gap: 0;
    width: 100%;
}

/* 活动流程表格 - 7列布局 */
.material-process-grid {
    display: grid;
    grid-template-columns: 13% 20% 12% 18% 15% 12% 10%;
    gap: 0;
    width: 100%;
}

/* 表头行 */
.material-grid-header {
    display: contents;
}

.material-grid-header .material-col {
    font-size: 12px;
    color: #606266;
    font-weight: 600;
    padding: 8px 4px;
    text-align: center;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-right: none;
    box-sizing: border-box;
}

.material-grid-header .material-col:last-child {
    border-right: 1px solid #e4e7ed;
}

/* 数据行 */
.material-item-row {
    display: contents;
}

.material-item-row > .el-input,
.material-item-row > .material-delete-cell {
    padding: 4px;
    box-sizing: border-box;
}

/* 输入框样式 */
.material-needs-grid .el-input,
.material-process-grid .el-input {
    width: 100% !important;
}

.material-needs-grid .el-input__wrapper,
.material-process-grid .el-input__wrapper {
    box-shadow: none !important;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    width: 100% !important;
}

.material-needs-grid .el-input__wrapper:hover,
.material-process-grid .el-input__wrapper:hover {
    border-color: #c0c4cc;
}

.material-needs-grid .el-input__wrapper.is-focus,
.material-process-grid .el-input__wrapper.is-focus {
    border-color: #f59e0b;
    box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1) !important;
}

/* 删除按钮样式 */
.material-delete-cell {
    display: flex;
    align-items: center;
    justify-content: center;
}

.material-delete-btn {
    width: 32px !important;
    height: 32px;
    transition: all 0.2s ease;
}

.material-delete-btn:hover {
    transform: scale(1.1);
}

/* 详情页表格样式 */
.detail-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 13px;
}

.detail-table thead tr {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.detail-table th {
    padding: 10px 8px;
    text-align: center;
    font-weight: 600;
    border: 1px solid #5a6fd6;
}

.detail-table td {
    padding: 10px 8px;
    text-align: center;
    border: 1px solid #ebeef5;
    background: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.detail-table tbody tr:nth-child(even) td {
    background: #fafafa;
}

.detail-table tbody tr:hover td {
    background: #f5f7fa;
}

/* Empty State */
.empty-card {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    background: white;
    border-radius: 16px;
    border: 2px dashed #e2e8f0;
    color: #94a3b8;
}

.empty-card i {
    font-size: 64px;
    margin-bottom: 20px;
    color: #cbd5e1;
}

.empty-card p {
    margin: 0;
    font-size: 15px;
    color: #64748b;
}

/* Pagination */
.pagination-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    padding: 20px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Search Input */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #f59e0b;
    background: white;
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

/* Responsive */
@media (max-width: 1400px) {
    .card-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 1100px) {
    .card-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }

    .card-grid {
        grid-template-columns: 1fr;
    }
}

/* Bento Grid */
.bento-grid {
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.filter-select {
    width: 110px;
}

.filter-select ::v-deep .el-input__inner {
    border: 1px solid #e4e7ed;
    background: #f5f7fa;
    border-radius: 4px;
    font-size: 12px;
    padding: 0 20px 0 8px;
}

.filter-select ::v-deep .el-input__wrapper {
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 4px;
}

.filter-select ::v-deep .el-select__caret {
    font-size: 12px;
}

.filter-select ::v-deep .el-select__tags {
    max-width: 80px !important;
}

.filter-select ::v-deep .el-select__tags > span {
    display: flex;
    flex-wrap: nowrap;
}

.filter-select ::v-deep .el-tag--mini {
    padding: 0 4px;
    height: 18px;
    line-height: 16px;
    font-size: 11px;
}

/* 下拉选项样式 */
.filter-select ::v-deep .el-select-dropdown__item {
    font-size: 11px;
    padding: 0 8px;
    height: 28px;
    line-height: 28px;
}

.filter-select ::v-deep .el-select-dropdown__item.hover,
.filter-select ::v-deep .el-select-dropdown__item:hover {
    background: #f5f7fa;
}

.filter-select ::v-deep .el-select-dropdown {
    font-size: 11px;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #f59e0b;
    font-size: 16px;
}

.card-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #94a3b8;
    background: #f8fafc;
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
}

.ai-hint i {
    font-size: 14px;
}

.card-content {
    padding: 4px 0;
}

/* 表格内文字截断 */
.introduce-text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 详情弹框样式 */
.detail-dialog ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    padding: 20px;
    border-radius: 8px 8px 0 0;
}

.detail-dialog ::v-deep .el-dialog__title {
    color: white;
    font-weight: 600;
}

.detail-dialog ::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: white;
}

.detail-content {
    padding: 20px;
}

.detail-section {
    margin-bottom: 24px;
}

.detail-section:last-child {
    margin-bottom: 0;
}

.detail-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    gap: 8px;
}

.detail-section-title i {
    color: #f59e0b;
}

.detail-row {
    display: flex;
    margin-bottom: 12px;
    font-size: 13px;
    line-height: 1.6;
}

.detail-label {
    width: 100px;
    flex-shrink: 0;
    color: #64748b;
    font-weight: 500;
}

.detail-value {
    flex: 1;
    color: #1e293b;
}

.detail-value.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/* 物料表头 - 已整合到上方详情页表格样式中 */

.detail-file-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border: 1px solid #fcd34d;
    border-radius: 6px;
    margin-right: 8px;
    margin-bottom: 8px;
    font-size: 12px;
    color: #92400e;
    cursor: pointer;
    transition: all 0.2s;
}

.detail-file-item:hover {
    background: linear-gradient(135deg, #fde68a 0%, #fcd34d 100%);
    transform: translateY(-1px);
}

.detail-file-item i {
    color: #d97706;
}

.detail-empty {
    color: #94a3b8;
    font-style: italic;
    font-size: 13px;
}

/* 活动类型上传样式 */
.activity-type-upload {
    width: 100%;
}

.activity-type-hint {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
    display: flex;
    align-items: center;
    gap: 4px;
}

.activity-type-hint i {
    color: #409eff;
}

/* 无图片占位符 */
.no-image {
    color: #c0c4cc;
    font-size: 12px;
    font-style: italic;
}

.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 20px;
}

/* 详情附件列表样式 */
.detail-file-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.detail-file-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 180px;
}

.detail-file-item:hover {
    background: #ecf5ff;
    border-color: #409eff;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.detail-file-item .file-icon {
    font-size: 24px;
    flex-shrink: 0;
}

.detail-file-item .file-info {
    flex: 1;
    min-width: 0;
}

.detail-file-item .file-name {
    font-size: 13px;
    color: #303133;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
}

.detail-file-item .file-preview-hint {
    font-size: 11px;
    color: #909399;
    margin-top: 2px;
}

.detail-file-item:hover .file-preview-hint {
    color: #409eff;
}

/* 图片预览弹窗 */
.preview-dialog ::v-deep .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    max-height: 80vh;
}

.preview-dialog .preview-image {
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
}
</style>
